import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Segment, Header, List } from 'semantic-ui-react';

function Privacy() {
  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Privacy Policy</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Header as="h1">Privacy Policy</Header>
          
          <Header as="h2">Information We Collect</Header>
          <List bulleted>
            <List.Item>Account information (name, email, password)</List.Item>
            <List.Item>Content you create (recipes, forum posts, comments)</List.Item>
            <List.Item>Usage data and preferences</List.Item>
            <List.Item>Device and browser information</List.Item>
          </List>

          <Header as="h2">How We Use Your Information</Header>
          <List bulleted>
            <List.Item>To provide and maintain our service</List.Item>
            <List.Item>To notify you about changes to our service</List.Item>
            <List.Item>To provide customer support</List.Item>
            <List.Item>To gather analysis or valuable information</List.Item>
            <List.Item>To monitor the usage of our service</List.Item>
            <List.Item>To detect, prevent and address technical issues</List.Item>
          </List>

          <Header as="h2">Data Security</Header>
          <p>
            The security of your data is important to us but remember that no method of transmission over the Internet
            or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to
            protect your Personal Data, we cannot guarantee its absolute security.
          </p>

          <Header as="h2">Your Data Protection Rights</Header>
          <List bulleted>
            <List.Item>The right to access your personal data</List.Item>
            <List.Item>The right to rectification of your personal data</List.Item>
            <List.Item>The right to erasure of your personal data</List.Item>
            <List.Item>The right to restrict processing of your personal data</List.Item>
            <List.Item>The right to data portability</List.Item>
            <List.Item>The right to object to processing of your personal data</List.Item>
          </List>

          <Header as="h2">Contact Us</Header>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
            <br />
            Email: privacy@soapee.com
          </p>
        </Segment>
      </Container>
    </>
  );
}

export default Privacy; 